import Logo from 'assets/svg/logo-ralali-big/logo-ralali-big.svg'
import LayoutAuth from 'common/components/LayoutAuth'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import redirect from 'lib/common/redirect'
import { useLoadedFlag } from 'lib/feature-flags'
import { setLocalStorage } from 'lib/local-storage'
import MediaHelper from 'lib/media-helper'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import OtpFlowModal from 'services/Auth/components/OtpFlowModal'
import RegisterForm from 'services/Auth/components/RegisterForm'
import MetaData from 'services/Auth/screens/Register/MetaData'
import IdProfiling from 'services/Questionnaire/constants'
import { useStoreActions, useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const WrapperLogo = styled.a`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  text-decoration: none;
  cursor: pointer;
  z-index: ${theme.zIndex.dropdown};

  ${MediaHelper('laptop')`svg {display: none;}`}
`

function RegisterV2({ lang }: { lang: string }): JSX.Element {
  const router = useRouter()

  const [showModal, setShowModal] = useState<boolean>(false)

  const {
    register: { step, username },
  } = useStoreState((state) => state)

  const {
    setStep,
    postSendOtp,
    postResendOtp,
    postVerifyOtp,
    setReferralCode,
  } = useStoreActions((actions) => actions.register)

  const { getFirstQuestionnaire } = useStoreActions(
    (actions) => actions.questionnaire,
  )

  const websiteUserProfilingGlobalFeature = useLoadedFlag(
    'biz--questionnaire--user-profiling--website',
  )

  const handleCloseRegister = () => {
    if (step === 'otp-form') return
    setStep('register-form')
  }

  const redirectLoginPage = () => {
    setLocalStorage('username_login', username)
    setStep('register-form')
    redirect('/login')
  }

  useEffect(() => {
    if (websiteUserProfilingGlobalFeature) {
      getFirstQuestionnaire(IdProfiling.profilingAccountType)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteUserProfilingGlobalFeature])

  useEffect(() => {
    if (router.query.referral) {
      setReferralCode(router.query.referral)
    }
    if (step === 'register-form') {
      setShowModal(false)
    } else if (
      step === 'otp-channel' ||
      step === 'otp-form' ||
      step === 'existing-user'
    ) {
      setShowModal(true)
    }
  }, [router.query.referral, setReferralCode, step])

  return (
    <LayoutAuth lang={lang} metaData={<MetaData />}>
      <WrapperLogo href={`${WEB_DESKTOP_RALALI_URL}`}>
        <Logo />
      </WrapperLogo>
      <RegisterForm responsive />
      <OtpFlowModal
        isOpen={showModal}
        handleClose={handleCloseRegister}
        step={step}
        handlePostSendOtp={postSendOtp}
        handlePostVerifyOtp={postVerifyOtp}
        handlePostResendOtp={postResendOtp}
        handleSetStep={setStep}
        handleRedirectLogin={redirectLoginPage}
        responsive
      />
    </LayoutAuth>
  )
}

export default RegisterV2
